import { required, email } from 'vee-validate/dist/rules';
import { extend } from "vee-validate";

export default function addVeeValidateRules() {
    extend('required', {
        ...required,
        message: 'Questo campo è richiesto',
    });

    extend('email', {
        ...email,
        message: 'Email non valida',
    })

    extend('fiscal_code', value => {
        if (/^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/.test(value)) {
            return true;
        }

        return 'Il codice fiscale inserito non è valido.';
    })
}
